/**
 * E&E Trading — Variant Table Row Click Handler
 * File: assets/ee-variant-table.js
 *
 * Makes each row in the price table clickable so clicking a row
 * automatically selects that variant in Horizon's native variant picker
 * (just like clicking the variant button directly).
 *
 * HOW TO INSTALL:
 *   1. Upload this file to your theme assets
 *   2. In theme.liquid, before </body>, add:
 *      {{ 'ee-variant-table.js' | asset_url | script_tag }}
 *   OR in Horizon's theme editor add a Custom HTML block with:
 *      <script src="{{ 'ee-variant-table.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  function initVariantTable() {
    const table = document.querySelector('.ee-variant-table');
    if (!table) return;

    const rows = table.querySelectorAll('.ee-variant-table__row[data-variant-id]');
    if (!rows.length) return;

    rows.forEach(function (row) {
      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
      row.setAttribute('aria-label', 'Select this pack size');

      function selectVariant() {
        const variantId = row.getAttribute('data-variant-id');
        if (!variantId) return;

        // ── Method 1: Horizon's native variant selector (radio inputs) ──
        // Horizon uses <input type="radio"> with value = variant id
        const radioInput = document.querySelector(
          `input[type="radio"][value="${variantId}"]`
        );
        if (radioInput) {
          radioInput.click();
          updateActiveRow(row);
          return;
        }

        // ── Method 2: Horizon select dropdown fallback ──
        const selectEl = document.querySelector('select[name="id"]');
        if (selectEl) {
          selectEl.value = variantId;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          updateActiveRow(row);
          return;
        }

        // ── Method 3: URL param update (last resort) ──
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
        updateActiveRow(row);
      }

      row.addEventListener('click', selectVariant);
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectVariant();
        }
      });
    });

    // Listen for Horizon's own variant change events to keep table in sync
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      const activeRow = table.querySelector(
        `[data-variant-id="${e.detail.variant.id}"]`
      );
      if (activeRow) updateActiveRow(activeRow);
    });
  }

  function updateActiveRow(selectedRow) {
    const table = selectedRow.closest('.ee-variant-table');
    if (!table) return;
    table.querySelectorAll('.ee-variant-table__row').forEach(function (r) {
      r.classList.remove('ee-variant-table__row--active');
    });
    selectedRow.classList.add('ee-variant-table__row--active');
    selectedRow.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  // Init after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantTable);
  } else {
    initVariantTable();
  }
})();
